<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
<!--    <Title :title="route" :button-array="buttonArray" @printpage="printpage"></Title>-->

    <Setp :nodes="nodes" :audits="audits"></Setp>

    <el-card class="box-card" style="min-height: 750px;margin-top: 15px" shadow="never">
      <el-form label-position="left" label-width="150px">
        <el-divider content-position="left">申请人信息</el-divider>

        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>

        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        <el-divider content-position="left">报销信息</el-divider>

        <el-table
            :data="detail.reimburseList"
            :cell-style="{color: 'black'}"
            @cell-mouse-leave="leave"
            @cell-mouse-enter="enter"
        >
          <el-table-column
              fixed
              prop="projectOrOffice"
              label="报销类型"
              width="220px"
              align="center"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.projectOrOffice==1">项目费用</span>
                <span v-if="scope.row.projectOrOffice==2">管理费用</span>
              </div>

              <div v-if="scope.row.projectOrOffice==1">
                <div>{{ scope.row.projectName }}</div>
                <el-button plain type="primary" size="mini"
                           @click="handleProjectDetail(scope.row.projectId)">项目信息
                </el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="reimburseType"
              label="报销名目"
              align="center"
              width="120px"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.reimburseType==1">交通费</span>
                <span v-if="scope.row.reimburseType==9">路桥费</span>
                <span v-if="scope.row.reimburseType==2">油费</span>
                <span v-if="scope.row.reimburseType==3">招待费</span>
                <span v-if="scope.row.reimburseType==4">住宿费</span>
                <span v-if="scope.row.reimburseType==5">餐补</span>
                <span v-if="scope.row.reimburseType==6">办公费</span>
                <span v-if="scope.row.reimburseType==7">办公费</span>
                <span v-if="scope.row.reimburseType==10">礼品费</span>
                <span v-if="scope.row.reimburseType==11">福利费</span>
                <span v-if="scope.row.reimburseType==8">其他</span>
              </div>
              <span v-if="scope.row.projectOrOffice==1&&scope.row.reimburseType==3" style="color: #409EFF">
              <el-button plain type="primary" size="mini"
                         @click="handleCostReportDetail(scope.row.costReportId)">招待详情</el-button>
            </span>
            </template>
          </el-table-column>

          <el-table-column
              prop="reimburseMode"
              label="报销模式"
              align="center"
              width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.reimburseMode==1">统一报销</span>
              <span v-if="scope.row.reimburseMode==2">独立报销</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="reimburseMoney"
              label="报销金额"
              align="center"
              width="150px"
          >
            <template slot-scope="scope">
              <span>￥{{ scope.row.reimburseMoney }}元</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="spendTime"
              label="费用产生时间"
              align="center"
              width="170px"
          >
          </el-table-column>

          <el-table-column
              prop="spendTime"
              label="外出信息"
              align="center"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.originAddress">出发地:{{ scope.row.originAddress }}</span>
                <span v-else>出发地:无</span>
              </div>
              <div>
                <span v-if="scope.row.endAddress">目的地:{{ scope.row.endAddress }}</span>
                <span v-else>出发地:无</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="remarks"
              label="费用事由"
              align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.remarks">{{ scope.row.remarks }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 15px;margin-right: 20px;clear: both;">
          <div style="float:right;">总金额: ￥{{
              detail.reimburseMoney
            }}元
          </div>
          <div style="float:right;margin-right: 20px;">编号: {{
              detail.reimburseNumber
            }}
          </div>
        </div>

        <div style="clear: both"></div>

        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>

        <div v-if="allowAudit==true">
          <el-divider content-position="left">我要审批</el-divider>

          <el-form-item label="审批意见" prop="remarks">
            <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                      v-model="ruleForm.auditOpinion"></el-input>
          </el-form-item>

          <el-Form-item>
            <el-popconfirm
              title="该操作无法撤回，是否已经仔细查阅？"
              @confirm="audit(2)">
              <el-button
                style="margin-left: 10px" slot="reference" type="primary">
                审批通过
              </el-button>
            </el-popconfirm>
            <el-popconfirm
              title="该操作无法撤回，是否已经仔细查阅？"
              @confirm="audit(3)">
              <el-button
                style="margin-left: 10px" slot="reference" type="danger">
                审批拒绝
              </el-button>
            </el-popconfirm>
          </el-Form-item>
        </div>

      </el-form>

    </el-card>
    <el-dialog
        title="项目信息"
        :visible.sync="projectShow"
        width="1200px"
        custom-class="custom-dialog"
        style=" margin: 0 14px 50px 0 !important;"
        :modal="false"
    >
      <ProjectDialog  style="padding: 20px" :projectId="projectId" :key="uuid"></ProjectDialog>
    </el-dialog>


    <el-dialog
        title="招待费报备详情"
        :visible.sync="costReportShow"
        width="1200px"
        custom-class="test-dialog"
        style=" margin: 0 14px 50px 0 !important;"
        :modal="false"
    >
      <CostReportDialog :costReportId="costReportId" :key="uuid"></CostReportDialog>
    </el-dialog>
    <div class="detail" v-if="detailShow">
      <Detail :detailId = "detailId" :reflash="reflash"></Detail>
    </div>

  </div>


</template>

<script>
import Title from "../../Title";
import {requestApplyDetail, requestAudit, requestAuditShow, requestPrintReimburse} from "../../../api";
import AuditList from "../common/AuditList";
import Setp from "../common/Setp";
import ProjectDialog from "../common/ProjectDialog";
import CostReportDialog from "../common/CostReportDialog";
import Detail from "../common/Detail";
import {uuid} from "../../../util";

export default {
  components: {CostReportDialog, ProjectDialog, AuditList, Title, Setp, Detail},
  name: "ReimburseDetail",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      route: {
        name: '费用报销申请详情',
        path: ''
      },
      detail: {
        reimburseList: [],
        reimburseMoney: 0,
      },
      audits: [],
      auditHistory: [],
      applyId: "",
      applyServiceId: "",
      applyType: "",
      ruleForm: {
        auditOpinion: "",
      },
      user: {},
      nodes: [],
      allowAudit: false,

      //reimburseMoney: 0,

      projectShow: false,
      projectId: "",
      costReportShow: false,
      costReportId: "",

      uuid: "",
      detailId: {
        costReportId: "",
        projectId: "",
        reimburseId: "",
        userId: ""
      },
      detailShow: false,
      reflash: Number
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    handleProjectDetail(projectId) {
      this.projectShow = true
      this.projectId = projectId
      this.uuid = uuid()
    },
    handleCostReportDetail(costReportId) {
      this.costReportShow = true
      this.costReportId = costReportId
      this.uuid = uuid()
    },

    getAuditShow() {
      requestAuditShow({
        applyId: this.applyId,
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            if (res.object == 1) {
              this.allowAudit = true
            }
            if (res.object == 2) {
              this.allowAudit = false
            }
          }
        }
      })
    },
    audit(isAgree) {

      this.allowAudit = false

      if (isAgree == 2 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "同意"
      }
      if (isAgree == 3 && !this.ruleForm.auditOpinion) {
        this.ruleForm.auditOpinion = "不同意"
      }

      requestAudit({
        isAgree: isAgree,
        applyId: this.applyId,
        applyType: this.applyType,
        auditOpinion: this.ruleForm.auditOpinion,
      }).then(res => {
        if (res.code == 200) {
          this.getAuditShow()
          this.getObject()
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            //this.reimburseMoney = res.object.totalMoney
            this.user = res.object.user
            this.nodes = res.object.nodes
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    printpage() {
      requestPrintReimburse({reimburseSingleId: this.detail.reimburseSingleId}).then(res => {
        if (res.code == 200) {
          window.location.href = res.object
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    enter(row, column, cell) {
      this.reset()
      if (row.costReportId || row.projectId) {
        this.detailId = {
          costReportId: row.costReportId,
          projectId: row.projectId,
        }
      }
      this.detailId.reimburseId = row.reimburseId
      this.detailId.userId = this.user.userId
      this.reflash = row.reimburseId
      this.detailShow = true
    },
    leave(row,column,cell) {
    },
    reset() {
      this.detailId = {
        costReportId: "",
        projectId: "",
        reimburseId: "",
        userId: ""
      }
    }
  }
}
</script>

<style>
.detail {
  width: 320px;
  position: fixed;
  left: 10px;
  top: 68px;
  z-index: 9999999;
}
::v-deep .custom-dialog .el-dialog {
  padding: 20px !important;
}
.test-dialog{
  padding: 20px !important;
  z-index: 9999 !important;
}
.fixed-setp {
  position: fixed;
  left: 10px;
  top: 68px;
  z-index: 9999999;
}
</style>




